var HELP_CENTER_APPLICATION_NAME = 'help-center-page';
var SEARCH_BAR_FLYOUT_APPLICATION_NAME = 'SearchBarFlyout';

export { HELP_CENTER_APPLICATION_NAME, SEARCH_BAR_FLYOUT_APPLICATION_NAME };
//# sourceMappingURL=constants.js.map
